import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isBrowser } from '../../youwell-common/browserUtils';

import * as PatientStore from '../../app/store/PatientStore';

class InternalLinkLoader extends React.Component {
    componentDidMount() {
        if (isBrowser) {
            // eslint-disable-next-line no-underscore-dangle
            window.__clickInternalLink = this.clickInternalLink;
        }
    }

    componentWillUnmount() {
        if (isBrowser) {
            // eslint-disable-next-line no-underscore-dangle
            window.__clickInternalLink = null;
        }
    }

    clickInternalLink = (elementId) => {
        const url = this.getLinkUrl({ url: elementId });
        this.props.redirect(url);
    }

    getLinkUrl = link => this.props.linkUrlFunction(link)

    render() {
        return null;
    }
}

InternalLinkLoader.propTypes = {
    redirect: PropTypes.func.isRequired,
    linkUrlFunction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    clientConfig: state.auth.clientConfig,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PatientStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(InternalLinkLoader);
